import {local} from 'wix-storage';
import wixLocation from 'wix-location'
import {endGame} from 'public/helper.js'
import moment from 'moment'
$w.onReady(async function () {
	endGame()
    let startTimeMili = local.getItem('startTime')
    let startTimeMoment = moment(startTimeMili, 'x')		
    $w('#time').text = "Elapsed Time: "+moment(moment().diff(startTimeMoment)).format("mm:ss")
    $w('#usedClues').text = "Used Clues: "+local.getItem('usedClues')
    $w('#members').text = "Members: "+local.getItem('teamName')
    $w('#scoreGroup').show()
});